import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { createLogger } from 'redux-logger';
import { createEpicMiddleware } from 'redux-observable';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import SitecoreContextFactoryService from '@services/sitecoreContextFactoryService';
import { USER_PROFILE_LOCALSTORAGE_KEY } from '@utils/constant';

import { CHECK_LOGIN_STATUS, CP_LOGIN_SUCCESS, CP_LOGOUT_SUCCESS, LOGIN_SUCCESS, LOGOUT_SUCCESS } from '../actions/singleSignOn/singleSignOnTypes';
import { rootEpic } from '../epic';
import { rootReducer } from '../reducers';

const persistConfig = {
  key: 'root',
  storage,
  blacklist: [
    'productReducer',
    'storeLocatorReducer',
    'wellnessReducer',
    'buyingOptionReducer',
    'checkoutProcesstReducer',
    'singleSignOnReducer',
    'unsubscribeReducer',
    'myAddressReducer',
    'searchBoxReducer',
    'commonSearchReducer',
    'sfExpressReducer',
    'bundleBOReducer',
    'myOrderReducer',
    'couponReducer',
    'settingGlobalReducer',
    'dynamicBundleReducer',
    'settingGlobalURLReducer',
    'couponWalletReducer',
    'clientTellingPortalCustomer',
    'clientTellingPortalQuickAccess',
    'productReviewReducer',
    'spinAndWinReducer',
    'compareProductReducer',
    'priorityDeliveryReducer',
    'getFreeGiftReducer',
    'controlSelectingFreeGiftPopupReducer',
    'eventBookingReducer',
    // 'loyaltyReducer',
    'subscribeNewsletterReducer',
    'campaignRegisterReducer',
    'myAppointmentReducer',
    'cpUpdateAppointmentReducer',
    'cpAppointmentDetailReducer',
    'cpNotificationPopupReducer',
    'layoutElementStyleReducer',
    'bookingExperienceReducer',
    'addFreeGiftToCartReducer',
    'updateFreeGiftToCartReducer',
    'cpNotificationPopupReducer',
    'addWarrantyReducer',
    'productWarrantyReducer',
    'cpCartDetailsReducer',
    'cpSaleOrderStatusesReducer',
    'getSOCartsReducer',
    'cpSendSaleOrderReducer',
    'personalizeOfferReducer',
    'taxMessageDetailReducer',
    'cpCheckContactDuplicateReducer',
    'mediaTrackingGoalReducer',
    'bopisReducer',
    'cPStartDemoReducer',
    'BOAddOnDealReducer'
  ]
};

// const persistedReducer = persistReducer(persistConfig, rootReducer);
const epicMiddleware = createEpicMiddleware();

export const configureStore = (editing) => {
  let reducer = null;
  if (editing) {
    reducer = rootReducer;
  } else {
    reducer = persistReducer(persistConfig, rootReducer);
  }

  const userAuthenticateMiddleware = store => next => action => {
    if (typeof window !== 'undefined') {
      const siteName = SitecoreContextFactoryService.getValueContextItem('site')?.name || '';
      let removeDomainFromUsernamePattern = new RegExp('^' + siteName.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '\\\\');
      const savedUserInfo = window.localStorage.getItem(USER_PROFILE_LOCALSTORAGE_KEY);

      switch (action.type) {
      case LOGIN_SUCCESS:
        window.localStorage.setItem(USER_PROFILE_LOCALSTORAGE_KEY, JSON.stringify({
          domain: siteName,
          name: action?.payload?.Username?.replace(removeDomainFromUsernamePattern, '') || '',
          isCPManager: false
        }));
        break;

      case CP_LOGIN_SUCCESS:
        window.localStorage.setItem(USER_PROFILE_LOCALSTORAGE_KEY, JSON.stringify({
          domain: siteName,
          name: action?.payload?.Data?.Username || '',
          isCPManager: true
        }));
        break;

      case LOGOUT_SUCCESS:
        window.localStorage.removeItem(USER_PROFILE_LOCALSTORAGE_KEY);
        break;

      case CP_LOGOUT_SUCCESS:
        window.localStorage.removeItem(USER_PROFILE_LOCALSTORAGE_KEY);
        break;

      case CHECK_LOGIN_STATUS:
        action.payload = {
          ...action.payload,
          user: action.payload.user || savedUserInfo ? JSON.parse(savedUserInfo) : null
        };
        break;
      }
    }

    return next(action);
  };
  
  const middlewares = [epicMiddleware, userAuthenticateMiddleware];

  if (process.env.NODE_ENV === 'development') {
    // middlewares.push(createLogger());
  }

  const composeEnhancers = composeWithDevTools({});

  const store = createStore(reducer, composeEnhancers(applyMiddleware(...middlewares)));

  epicMiddleware.run(rootEpic);

  return store;
};
